import { Box } from '@chakra-ui/react'
import { FormElement } from '@components/forms/Input'
import { useProfile } from '@contexts/user/ProfileContext'
import { SectionLabel } from '../../SectionLabel'
import {
  Assessment,
  getCorrectedValue,
  getGestationalAgeDays,
  ultrasoundHeaderField,
} from '@hb/shared'
import { useEffect, useMemo } from 'react'
import { useField, useForm } from 'react-final-form'

export const UltrasoundHeaderInput = () => {
  const form = useForm()
  const {
    selectedAssessment: { populated: assessment },
  } = useProfile()

  const edd = useMemo(
    () => getCorrectedValue(assessment as Assessment | null, 'delivery.edd') as number | undefined,
    [assessment],
  )

  const {
    input: { value: encounterDate },
  } = useField<string>('date', { subscription: { value: true } })

  const {
    input: { value: studyDate },
  } = useField<string | undefined>('data.studyDate', { subscription: { value: true } })

  const {
    input: { value: existingGa },
  } = useField<number | undefined>('data.gaAtStudyDays', { subscription: { value: true } })

  // Auto-populate GA from EDD + study date (or encounter date) on mount and when study date changes.
  useEffect(() => {
    if (existingGa) return
    const refDate = studyDate || encounterDate
    if (!edd || !refDate) return
    const days = getGestationalAgeDays(edd, refDate)
    if (days != null) form.change('data.gaAtStudyDays', days)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studyDate, encounterDate, edd])

  return (
    <Box data-child-name="data" w="100%" px={4} py={3}>
      <SectionLabel>Report Header</SectionLabel>
      <FormElement root showName={false} field={ultrasoundHeaderField} name="data" />
    </Box>
  )
}
